/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-08 12:30:39
 *
 *******************************************************/
// @flow

import { SEPARATE } from 'src/constants/site';
import { ALL_VALUES_FILTER_OPTION } from 'src/constants/filter-tree';
import { convertArrayToString } from './index';

export const collectFilterTreeStatus = (searchFilterTrees, customFilterTrees) => {
  let filterTreeStatus = {};
  for (const filterTree of searchFilterTrees) {
    const { filterId, status } = filterTree;
    filterTreeStatus[filterId] = status === 'active' ? true : false;
  }
  for (const filterTree of customFilterTrees) {
    const { filterId, status } = filterTree;
    filterTreeStatus[filterId] = status === 'active' ? true : false;
  }

  return filterTreeStatus;
};

export const collectionsExpandStatus = customFilterTrees => {
  let collectionsExpand = {};
  for (const filterTree of customFilterTrees) {
    const { filterId } = filterTree;
    collectionsExpand[filterId] = false;
  }

  return collectionsExpand;
};

// Get filter option value to display in filter option list
export function getFilterOptionValue(data, i18n) {
  let type = data.filterType;
  let values = data.manualValues;
  if (data.valueType === 'all') {
    return i18n.translate(ALL_VALUES_FILTER_OPTION);
  } else {
    if (type === 'collection' || type === 'stock') {
      let temp = [];
      if (data.displayType === 'sub_category') {
        for (let k in values) {
          let subCat = '';
          if (values[k]['tags']) {
            subCat = '\n      ' + values[k]['tags'].join('\n      ');
          }
          temp.push(values[k]['label'] + subCat);
        }
      } else {
        for (let k in values) {
          temp.push(values[k]['label']);
        }
      }
      values = temp;
    }

    if (type === 'price' || type === 'percent_sale') {
      if (values !== null && typeof values !== 'undefined') {
        let priceList = [];
        for (let k = 0; k < values.length; k++) {
          let tempArr = values[k].split(':');
          for (let i = 0; i < tempArr.length; i++) {
            if (parseInt(tempArr[i]) > 0 && priceList.indexOf(tempArr[i]) === -1) {
              priceList.push(tempArr[i]);
            }
          }
        }
        return priceList.join(';');
      }
    } else {
      if (Array.isArray(values)) {
        if (type === 'collection' && data.displayType === 'sub_category') {
          values = convertArrayToString(values, SEPARATE.NEW_LINE);
        } else if (type === 'multi_level_tag') {
          values = convertArrayToString(values.map(value => value.tag), SEPARATE.SELECT);
        } else {
          values = convertArrayToString(values, SEPARATE.SELECT);
        }
      }
    }
    return values;
  }
}
